export const baseUrl = 'https://garant-hr.uz/api/public/api'